import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Notiz } from 'sharedTypes/notiz';
import { FirebaseService } from 'src/app/services/firebase.service';
import { GlobalService } from 'src/app/services/global.service';

@Component({
    selector: 'app-client-notizen',
    standalone: false,
    templateUrl: './client-notizen.component.html',
    styleUrls: ['./client-notizen.component.scss'],
})
export class ClientNotizenComponent implements OnInit {
    @Input() clientId: string = '';
    @Input() leadId: string = '';
    lNotizen: Array<Notiz> = [];
    cNotizen: Array<Notiz> = [];
    filtered: Array<Notiz> = [];
    notizenSub: Subscription = new Subscription();
    showArchived = false;

    constructor(private firebaseService: FirebaseService, public glo: GlobalService, private cdr: ChangeDetectorRef) {}

    ngOnInit(): void {
        if (this.clientId) {
            this.notizenSub = this.firebaseService.getClientNotizen(this.clientId).subscribe((notizen) => {
                this.cNotizen = notizen;
                this.filterNotizen();
            });
        }
        if (this.leadId) {
            this.notizenSub = this.firebaseService.getLeadNotizen(this.leadId).subscribe((notizen) => {
                this.lNotizen = notizen;
                this.filterNotizen();
            });
        }
    }

    filterNotizen() {
        this.filtered = this.cNotizen.concat(this.lNotizen).filter((n) => !n.archiv || this.showArchived);
        this.cdr.detectChanges();
    }
    toggleShowArchived() {
        this.showArchived = !this.showArchived;
        this.filterNotizen();
    }

    ngOnDestroy(): void {
        this.notizenSub.unsubscribe();
    }
}
